import React, { useEffect, useRef, useState } from 'react';
import { UserRound, Handshake } from 'lucide-react';

// Acesso rápido fixo no topo, no mesmo formato das abas do site (Pacotes/Prêmios/Baús).
// A altura da barra de compradores é medida em tempo real (ela pode não existir).
const TAB = 'inline-flex items-center justify-center whitespace-nowrap rounded-md px-3 py-1.5 '
  + 'text-xs sm:text-sm font-semibold text-white shadow-sm transition-all '
  + 'hover:brightness-110 active:scale-[0.98]';

export const TopAccessBar = ({ account, authPending = false, onBottom }) => {
  const ref = useRef(null);
  const [top, setTop] = useState(0);

  useEffect(() => {
    const medir = () => {
      const marquee = document.querySelector('[data-testid="buyers-bar"]');
      const t = marquee ? Math.round(marquee.getBoundingClientRect().height) : 0;
      const h = ref.current ? Math.round(ref.current.getBoundingClientRect().height) : 52;
      setTop(t);
      if (onBottom) onBottom(t + h);
    };
    medir();
    const t1 = setTimeout(medir, 900);
    const t2 = setTimeout(medir, 2600);
    window.addEventListener('resize', medir);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
      window.removeEventListener('resize', medir);
    };
  }, [onBottom]);

  const logado = !!account;
  // Enquanto a conta do cliente carrega, não mostra nada de visitante (evita piscar)
  const visitante = !logado && !authPending;
  // Painel do Afiliado só para visitante (pode ser afiliado querendo entrar) ou cliente afiliado
  const mostraAfiliado = logado ? !!account.is_affiliate : visitante;

  return (
    <div ref={ref} className="fixed left-0 right-0 z-40 px-4 pt-2" style={{ top }}
         data-testid="top-access-bar">
      <style>{`
        @keyframes tab-glow {
          0%, 100% { box-shadow: 0 0 0 0 rgba(249,115,22,0.55); }
          50% { box-shadow: 0 0 0 8px rgba(249,115,22,0); }
        }
        .tab-glow { animation: tab-glow 1.7s ease-out 4; }
      `}</style>
      <div className={`max-w-3xl lg:max-w-lg xl:max-w-xl mx-auto grid gap-1 p-1
                      rounded-lg bg-white/85 backdrop-blur-md border border-white/70
                      shadow-lg shadow-purple-900/10 ${mostraAfiliado ? 'grid-cols-2' : 'grid-cols-1'}`}>
        <a href="/conta"
           data-testid={visitante ? 'top-access-login' : 'top-access-account'}
           title={visitante ? 'Entrar ou criar sua conta' : 'Abrir Minha Conta'}
           className={`${TAB} bg-gradient-to-r from-orange-500 to-red-600 ${visitante ? 'tab-glow' : ''}`}>
          <UserRound className="w-3.5 h-3.5 sm:w-4 sm:h-4 mr-1.5" strokeWidth={2.6} />
          {visitante ? 'Entrar' : 'Minha Conta'}
        </a>
        {mostraAfiliado && (
          <a href="/reseller/login"
             data-testid="top-access-affiliate"
             title="Painel do Afiliado — vendas e comissões"
             className={`${TAB} bg-gradient-to-r from-purple-600 to-blue-600`}>
            <Handshake className="w-3.5 h-3.5 sm:w-4 sm:h-4 mr-1.5" strokeWidth={2.6} />
            <span className="hidden sm:inline">Painel do Afiliado</span>
            <span className="sm:hidden">Afiliado</span>
          </a>
        )}
      </div>
    </div>
  );
};

export default TopAccessBar;
